import { useState, useEffect } from 'react'
import Card, { CardHeader, CardTitle, CardBody } from './Card'
import Pill from './Pill'
import ExperimentCard from './ExperimentCard'
import axios from 'axios'

export default function ExperimentsList() {
  const [experiments, setExperiments] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchExperiments = async () => {
      try {
        const response = await axios.get('/api/v1/experiments', {
          timeout: 5000 // 5 second timeout
        })
        if (response.data && Array.isArray(response.data)) {
          setExperiments(response.data)
        } else {
          console.warn('Unexpected response format:', response.data)
          setExperiments([])
        }
      } catch (error) {
        console.error('Failed to fetch experiments:', error)
        if (error.response) {
          // Server responded with error status
          console.error('Response status:', error.response.status)
          console.error('Response data:', error.response.data)
        } else if (error.request) {
          // Request made but no response
          console.error('No response received. Is the backend running?')
        }
        // Set empty array instead of fallback - let user see "No experiments yet"
        setExperiments([])
      } finally {
        setLoading(false)
      }
    }

    fetchExperiments()
  }, [])

  return (
    <section className="mt-8 mb-8" id="experiments" aria-label="Experiments">
      <Card>
        <CardHeader>
          <CardTitle>Experiments</CardTitle>
          <Pill>states, not pages</Pill>
        </CardHeader>
        <CardBody>
          <div className="grid grid-cols-1 gap-3 mt-1.5">
            {loading ? (
              <div className="text-muted-dark text-center py-8">Loading experiments...</div>
            ) : experiments.length > 0 ? (
              experiments.map(exp => (
                <ExperimentCard key={exp.id} experiment={exp} />
              ))
            ) : (
              <div className="text-muted-dark text-center py-8">No experiments yet.</div>
            )}
          </div>

          {/* Research Publications Link */}
          <div className="mt-6 pt-4 border-t border-border-dark">
            <div className="text-center">
              <p className="text-sm text-muted-dark mb-3">
                Explore experimental observations and strategic insights
              </p>
              <a
                href="/notes"
                className="inline-flex items-center gap-2 text-accent-dark hover:underline font-medium text-sm"
              >
                <span>View Observations</span>
                <span>→</span>
              </a>
            </div>
          </div>
        </CardBody>
      </Card>
    </section>
  )
}

